var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgThumb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 90,
    viewBox: "0 -50 100 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.9167 17H8.08333C4.72361 17 2 19.7236 2 23.0833V83.9167C2 87.2765 4.72361 90 8.08333 90H68.9167C72.2765 90 75 87.2765 75 83.9167V23.0833C75 19.7236 72.2765 17 68.9167 17Z",
    stroke: "#A0B2C0",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3303 51.4716C31.9298 51.4716 36.4692 46.9322 36.4692 41.3327C36.4692 35.7332 31.9298 31.1938 26.3303 31.1938C20.7308 31.1938 16.1914 35.7332 16.1914 41.3327C16.1914 46.9322 20.7308 51.4716 26.3303 51.4716Z",
    stroke: "#A0B2C0",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75 77.8342L55.3716 59.9902C53.8516 58.6084 51.532 58.6026 50.0051 59.9768L35.0281 73.4561C33.5344 74.8005 31.275 74.8278 29.7491 73.5199L20.6584 65.7279C19.235 64.5078 17.1551 64.4401 15.6553 65.5649L2 75.8064",
    stroke: "#A0B2C0",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9692 7.05909C22.2688 3.71276 25.2245 1.24289 28.5708 1.54252L89.1617 6.96769C92.5082 7.26732 94.978 10.223 94.6783 13.5693L89.2532 74.1602C88.9535 77.5067 85.998 79.9764 82.6515 79.6768",
    stroke: "#A0B2C0",
    strokeWidth: 3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgThumb);
export default __webpack_public_path__ + "static/media/img-thumb.08893a1402a7edf018c56515dd009f00.svg";
export { ForwardRef as ReactComponent };